export default __webpack_public_path__ + "static/media/_empty-chart-performance-bg.1ac0b457.svg";